import { Checkbox as AntCheckbox } from "antd"

type Props = {
  label: string
  defaultChecked?: boolean
  style?: {}
  disabled?: boolean
  checked?: boolean
  onChange?: any
}

export const CheckBox: React.FC<Props> = ({
  label,
  defaultChecked,
  style,
  disabled,
  checked,
  onChange,
}) => (
  <AntCheckbox
    defaultChecked={defaultChecked}
    style={style}
    disabled={disabled}
    checked={checked}
    onChange={onChange}
  >
    {label}
  </AntCheckbox>
)
